import Modal from "../../ui/Modal";
import Form from "../../ui/Form";
import { useCreateCustomerMutation, useUpdateCustomerMutation } from "../../utils/customer.utils";
import CustomerAddressField from "./CustomerAddressField";
import { checkCreateOrUpadateCustomerAddressValues } from "../../utils/address.utils";

export default function CustomerAddEdit({ modal, toggle, editItem, editType = 3 }) {
  const id = editItem?.id ?? "";

  const { loading, createCustomer } = useCreateCustomerMutation(["createCustomer"]);

  const { loading: updating, updateCustomer } = useUpdateCustomerMutation(["updateCustomer"]);

  const genereFields = [
    {
      label: "Name",
      name: "name",
      type: "text",
      placeholder: "Enter a name",
      col: { md: 12 },
      rules: { required: "This is required field!" }
    },
    {
      label: "Mobile",
      name: "mobile",
      type: "text",
      placeholder: "Enter a mobile number",
      col: { md: 12 }
    },
    {
      label: "Email",
      name: "email",
      type: "email",
      placeholder: "Enter an email",
      col: { md: 12 }
    },
    {
      label: "Gender",
      name: "gender",
      type: "radio",
      col: { md: 6 },
      options: [
        {
          value: "1",
          label: "Male"
        },
        {
          value: "2",
          label: "Female"
        }
      ]
    }
  ];

  const addressFields = [
    {
      name: "customerAddress",
      type: "custom",
      customComponent: CustomerAddressField,
      col: { md: 12 }
    }
  ];

  let fields = [];

  if (editType === 1) {
    // profile edit
    fields = [...genereFields];
  } else if (editType === 2) {
    // address edit
    fields = [...addressFields];
  } else if (editType === 3) {
    fields = [...genereFields, ...addressFields];
  }

  const defaultValues = {
    id: editItem?.id ?? "",
    name: editItem?.name ?? "",
    email: editItem?.email ?? "",
    mobile: editItem?.mobile ?? "",
    gender: editItem?.gender ?? "1",
    address: {
      id: editItem?.address?.id ?? "",
      is_dhaka_city: editItem?.address?.is_dhaka_city ? editItem?.address?.is_dhaka_city + "" : "1",
      address_type: editItem?.address?.type_id ? editItem?.address?.type_id + "" : "1",
      thana: editItem?.address?.dhaka_city?.dhaka_city_thana
        ? {
            label:
              editItem?.address?.dhaka_city?.dhaka_city_thana?.name +
              " - " +
              editItem?.address?.dhaka_city?.dhaka_city_thana?.post_code,
            value: editItem?.address?.dhaka_city?.dhaka_city_thana?.id
          }
        : "",
      area: editItem?.address?.dhaka_city?.id
        ? {
            label: editItem?.address?.dhaka_city?.name,
            value: editItem?.address?.dhaka_city?.id
          }
        : "",
      street: editItem?.address?.street ?? "",
      division: editItem?.address?.division
        ? {
            label: editItem?.address?.division?.name,
            value: editItem?.address?.division?.id
          }
        : "",
      district: editItem?.address?.district
        ? {
            label: editItem?.address?.district?.name,
            value: editItem?.address?.district?.id
          }
        : "",
      upazila: editItem?.address?.upazila
        ? {
            label: editItem?.address?.upazila?.name,
            value: editItem?.address?.upazila?.id
          }
        : "",
      union: editItem?.address?.union
        ? {
            label: editItem?.address?.union?.name,
            value: editItem?.address?.union?.id
          }
        : "",
      village: editItem?.address?.village
        ? {
            label: editItem?.address?.village?.name,
            value: editItem?.address?.village?.id
          }
        : "",
      post_office: editItem?.address?.post_office
        ? {
            label: editItem?.address?.post_office?.name,
            value: editItem?.address?.post_office?.id
          }
        : ""
    }
  };

  const onSubmit = async (data) => {
    const address = data?.address ?? {};
    const street = address?.street ?? "";
    const type_id = address?.address_type ?? "";
    const isDhakaCity = address?.is_dhaka_city ?? "";

    const commonAddress = {
      street,
      type_id,
      id: address?.id ?? "",
      is_dhaka_city: address?.is_dhaka_city ?? ""
    };

    const notDhakaCityAddress = {
      division_id: address?.division?.value ?? "",
      district_id: address?.district?.value ?? "",
      upazila_id: address?.upazila?.value ?? "",
      union_id: address?.union?.value ?? "",
      village_id: address?.village?.value ?? "",
      post_office_id: address?.post_office?.value ?? "",
      ...commonAddress
    };

    const dhakaCityAddress = {
      dhaka_city_id: address?.area?.value ?? "",
      ...commonAddress
    };

    let customerAddress = isDhakaCity === "1" ? dhakaCityAddress : notDhakaCityAddress;

    if (!checkCreateOrUpadateCustomerAddressValues(customerAddress)) {
      customerAddress = null;
    }

    const name = data?.name ?? "";
    const email = data?.email ?? "";
    const mobile = data?.mobile ?? "";
    const gender = data?.gender ?? "";

    const values = {
      ...(customerAddress && editType === 2 ? { address: customerAddress } : {}),
      ...(customerAddress && editType === 1 ? { name, email, mobile, gender } : {}),
      ...(customerAddress && editType === 3
        ? { name, email, mobile, gender, address: customerAddress }
        : {})
    };

    if (!!id) {
      const afterUpdated = await updateCustomer({ id, ...values });

      if (afterUpdated?.status === 200) {
        toggle();
      }
      return;
    }

    const afterCreated = await createCustomer({ ...values });

    if (afterCreated?.status === 201) {
      toggle();
    }
  };

  const isLoading = loading || updating;

  const title = `${!!id ? "Update" : "Create"} Customer`;

  return (
    <Modal modal={modal} toggle={toggle} title={title}>
      <Form
        fields={fields}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
        submitbtnText={isLoading ? `${!!id ? "Updating..." : "Creating...."}` : title}
        toggle={toggle}
        loading={typeof isLoading === "boolean" ? isLoading : undefined}
      />
    </Modal>
  );
}
